import { useTranslation } from 'react-i18next';

import lockupUrl from '../../ui/brand/gradex-lockup-violet-ink.svg';
import './layouts.css';

/**
 * The Gradex lockup (violet mark, ink wordmark). It always links to the
 * app's own root (`/`), which takes a signed-in person to their area's
 * overview and anyone else to sign-in. The image has fixed dimensions, so
 * it never shifts the page.
 */
export function Lockup() {
  const { t } = useTranslation();
  return (
    <a href="/" className="lockup" aria-label={t('app.homeLink')}>
      <img src={lockupUrl} alt="" width={148} height={40} />
    </a>
  );
}
